module.exports = __webpack_public_path__ + "img/43287d1.png";